import { render, staticRenderFns } from "./Type8Block.vue?vue&type=template&id=eabccec8&scoped=true&"
import script from "./Type8Block.vue?vue&type=script&lang=js&"
export * from "./Type8Block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabccec8",
  null
  
)

export default component.exports